module.exports = __webpack_public_path__ + "img/话术字典.e7afb04e.svg";